import Grid from '@material-ui/core/Grid'
import React from 'react'
import EkomApi from '../../api/EkomApi'
import Loading from '../../customs/Loading/Loading'
import { useFetch } from '../../hooks/useFetch'
import Error from '../../parts/Error'
import { iMsgAttachment } from '../../types/msg.types'
import FileCard from './FileCard'
import { useStyles } from './styles'

interface iMsgDetailFiles {
  id: string
  isSent: boolean
  extSystem: string
  extMsgId: string
}

const MsgDetailFiles = ({ id, isSent, extSystem, extMsgId }: iMsgDetailFiles) => {
  const classes = useStyles()

  const { data, error, loading } = useFetch<iMsgAttachment[]>(
    () => isSent ? EkomApi.getMsgOutgoingDetailFiles(id) : EkomApi.getMsgIncomingDetailFiles(id)
  )

  if (loading) {
    return <Loading/>
  }
  if (!extSystem) {
    return <Error>Přílohy nejsou dostupné, protože zdrojový systém již není dostupný.</Error>
  }

  if (error) {
    return <Error>Přílohy nejsou momentálně dostupné: {error}</Error>
  }
  if (!data || !data.length) {
    return null
  }

  return (
    <Grid container spacing={0} className={classes.intro}>

      <Grid item sm={12} className={classes.msgtitle}>
        Přílohy:
      </Grid>

      <Grid item sm={12}>
        <div className={classes.fileArea}>
          {data.map((file, index) => (
            <FileCard
              key={index}
              file={file}
              extSystem={extSystem}
              extMsgId={extMsgId}
            />
          ))}
        </div>

      </Grid>

    </Grid>
  )
}

export default MsgDetailFiles
